import { type VendorInviteApiModel } from '../api-models/VendorInviteApiModel'
import { type VendorInvite } from '../types/VendorInvite'

export const mapVendorInviteApiModel = (
  data: VendorInviteApiModel
): VendorInvite => ({
  id: data.id,
  vendorId: data.vendor_id,
  contactEmail: data.contact_email,
  status: data.status,
})
